/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect } from "react";

import { useFormContext } from "react-hook-form";

import { PreloaderScreen } from "@/components";
import { useRedirect } from "@/hooks/useRedirect";
import { PageWithHardStopProps } from "@/types/SolarFormProps";

import { serviceProviderMatching } from "./content.json";
import { useSoftQuote } from "./useSoftQuote";

type ServiceProviderMatchingProps = Omit<PageWithHardStopProps, "backRoute"> & {
  delay: number;
};

export const ServiceProviderMatching = memo(
  ({ delay, nextRoute, hardStopRoute }: ServiceProviderMatchingProps) => {
    const { setValue } = useFormContext();
    const { goNextRoute } = useRedirect();
    const { loading, serviceProviderDetails } = useSoftQuote();

    const navigateHardStop = async () => {
      setValue("hardStop", "softQuote");
      goNextRoute(await hardStopRoute());
    };

    useEffect(() => {
      const timeoutId = setTimeout(async () => {
        if (
          !serviceProviderDetails ||
          serviceProviderDetails instanceof Error
        ) {
          await navigateHardStop();

          return;
        }

        if (!loading && serviceProviderDetails.length) {
          setValue("fetchedServiceProviderDetails", serviceProviderDetails);
          setValue("selectedServiceProviders", []);
          goNextRoute(await nextRoute());
        }
      }, delay);

      return () => clearTimeout(timeoutId);
    }, [loading, serviceProviderDetails]);

    return (
      <PreloaderScreen
        id={serviceProviderMatching.id}
        heading={serviceProviderMatching.heading}
        description={serviceProviderMatching.description}
      />
    );
  }
);
